<div class="container single-view" id="add-product-customization">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/product-customisations/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'PRODUCT_CUSTOMIZATIONS.BTN_BACK_TO_PRODUCT_CUSTOMIZATION' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-productcustomization-title" class="section-title">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-productcustomization-subtitle" class="section-subtitle mt-1 text-base">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="productCustomisationsForm" data-testid="add-productcustomisation-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.PRODUCT_CUSTOMIZATIONS_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-productcustomisation-field-productId" class="block text-sm" for="productId">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.PRODUCT' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="product"
                    [placeholder]="'PRODUCT_CUSTOMIZATIONS_CREATE.SELECT_PRODUCT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="productId"
                    (onLazyLoad)="onLazyLoadComboData($event)"
                    (onChange)="onProductChange($event)">
                  </app-custom-dropdown>

                  @if (productCustomisationsForm.get('productId')?.invalid && productCustomisationsForm.get('productId')?.touched) {
                    <small data-testid="product-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-productcustomisation-field-name" class="block text-sm" for="name">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-productcustomisation-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (productCustomisationsForm.get('name')?.invalid && productCustomisationsForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <label data-testid="add-productcustomisation-field-imageurl" class="block text-sm" for="imageUrl">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.THUMBNAIL' | translate }}</label>
                  <input data-testid="add-productcustomisation-imageurl-input" type="text" id="imageUrl" formControlName="imageUrl" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <label data-testid="add-productcustomisation-field-description" class="block text-sm"
                    for="description">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.SHORT_DESCRIPTION' | translate }} <i
                  class="icon-required-field"></i></label>
                  <input data-testid="add-productcustomisation-description-input" type="text" id="description"
                    formControlName="description" autocomplete="off">
                  @if (productCustomisationsForm.get('description')?.invalid && productCustomisationsForm.get('description')?.touched) {
                    <small data-testid="description-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                @if (canViewPrice) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                    <label data-testid="add-productcustomisation-field-price" class="block text-sm" for="price">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.PRICE' | translate }}</label>
                    <input data-testid="add-productcustomisation-price-input" type="text" id="price" formControlName="price" autocomplete="off">
                  </div>
                }

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <label data-testid="add-productcustomisation-field-code" class="block text-sm" for="code">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.PRODUCT_CODE' | translate }} <i
                  class="icon-required-field"></i></label>
                  <input data-testid="add-productcustomisation-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                </div>

                <!-- Dynamic product attributes -->
                @if (productAttributesFeatureEnabled && productAttributeDefinitions.length) {
                  <ng-container formArrayName="productAttributes">
                    @for (attribute of productAttributesArray.controls; track attribute; let i = $index) {
                      <ng-container [formGroupName]="i">
                        <!-- Type FIXED_VALUES (dropdown) -->
                        @if (isFixedValuesAttribute(attribute)) {
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <label class="block text-sm" [for]="'product-customisation-attribute-' + i">
                              {{ getAttributeLabel(productAttributeDefinitions[i]) }}
                            </label>
                            <app-custom-dropdown [data-testid]="'product-customisation-attribute-' + i"
                              [placeholder]="('PRODUCT_CREATE.SELECT' | translate) + ' ' + getAttributeLabel(productAttributeDefinitions[i]).toLowerCase()"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="allowMultipleValuesAttribute(attribute)"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [showSearchbox]="false"
                              [searchMode]="'local'"
                              [options]="getProductAttributeDropdownOptions(productAttributeDefinitions[i])"
                              formControlName="value">
                            </app-custom-dropdown>
                          </div>
                        }
                        <!-- Type INTEGER / DECIMAL / TEXT single -->
                        @if (!isFixedValuesAttribute(attribute) && !allowMultipleValuesAttribute(attribute)) {
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <label class="block text-sm" [for]="'product-customisation-attribute-single-' + i">
                              {{ getAttributeLabel(productAttributeDefinitions[i]) }}
                            </label>
                            @if (!isTextAttribute(attribute)) {
                              <input [id]="'product-customisation-attribute-single-' + i" type="number" [step]="isIntegerAttribute(attribute) ? '1' : '0.01'" formControlName="value" autocomplete="off">
                            }
                            @if (attribute.get('value')?.touched && attribute.get('value')?.invalid) {
                              @if (attribute.get('value')?.hasError('pattern')) {
                                <small class="p-error">{{ 'FORMS.INVALID_FORMAT_INTEGER_ONLY' | translate }}</small>
                              }
                            }
                            @if (isTextAttribute(attribute)) {
                              <input [id]="'product-customisation-attribute-single-' + i" type="text" formControlName="value" autocomplete="off">
                            }
                          </div>
                        }
                        <!-- Type INTEGER / DECIMAL / TEXT multivalued -->
                        @if (!isFixedValuesAttribute(attribute) && allowMultipleValuesAttribute(attribute)) {
                          <ng-container formArrayName="values">
                            @for (valueControl of getNumericValuesArray(i).controls; track valueControl; let j = $index) {
                              <div class="field-wr btn-field flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                <label [for]="'product-customisation-attribute-' + i + '-' + j" class="block text-sm mb-2">
                                  {{ getAttributeLabel(productAttributeDefinitions[i]) }} #{{ j + 1 }}
                                </label>
                                <div class="flex flex-col">
                                  <div class="flex gap-2">
                                    @if (!isTextAttribute(attribute)) {
                                      <input
                                        [id]="'product-customisation-attribute-' + i + '-' + j"
                                        type="number"
                                        [step]="isIntegerAttribute(attribute) ? '1' : '0.01'"
                                        [formControlName]="j"
                                        autocomplete="off">
                                    }
                                    @if (isTextAttribute(attribute)) {
                                      <input
                                        [id]="'product-attribute-' + i + '-' + j"
                                        type="text"
                                        [formControlName]="j"
                                        autocomplete="off">
                                    }
                                    @if (getNumericValuesArray(i).length > 1) {
                                      <button type="button" data-testid="remove-btn" class="btn primary-btn remove-btn" pTooltip="{{ 'PRODUCT_CREATE.BTN_REMOVE_ATTRIBUTE_VALUE' | translate }}" tooltipPosition="top" (click)="removeNumericMultiValue(i, j)">
                                        <span class="btn-label">{{ 'PRODUCT_CREATE.BTN_REMOVE_ATTRIBUTE_VALUE' | translate }}</span>
                                      </button>
                                    }
                                    @if (j === getNumericValuesArray(i).length - 1 && getNumericValuesArray(i).length < 10) {
                                      <button type="button" data-testid="add-btn" class="btn primary-btn add-btn" pTooltip="{{ 'PRODUCT_CREATE.BTN_ADD_ATTRIBUTE_VALUE' | translate }}" tooltipPosition="top" (click)="addNumericMultiValue(i)">
                                        <span class="btn-label">{{ 'PRODUCT_CREATE.BTN_ADD_ATTRIBUTE_VALUE' | translate }}</span>
                                      </button>
                                    }
                                  </div>
                                  @if (valueControl.touched && valueControl.invalid) {
                                    @if (valueControl.hasError('pattern')) {
                                      <small class="p-error">
                                        {{ 'FORMS.INVALID_FORMAT' | translate }}
                                      </small>
                                    }
                                  }
                                </div>
                              </div>
                            }
                          </ng-container>
                        }
                      </ng-container>
                    }
                  </ng-container>
                }

                <div class="field-wr flex flex-col col-12">
                  <label data-testid="add-productcustomisation-field-comment" class="block text-sm" for="comment">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.COMMENTS' | translate }}</label>
                  <textarea data-testid="add-productcustomisation-comment-input" type="text" id="comment" formControlName="comment" autocomplete="off"></textarea>
                </div>

              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-productcustomisation-create-productcustomisation" class="btn primary-btn" [disabled]="productCustomisationsForm.invalid" (click)="submitForm()">{{ 'PRODUCT_CUSTOMIZATIONS_CREATE.BTN_CREATE_PRODUCT_CUSTOMIZATION' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
